module.exports = __webpack_public_path__ + "static/media/water_new.038ca2de.png";